import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { pnpLogo } from '../Asserts';
import { useNavigate } from 'react-router';
import { Flip, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { baseURL } from "../services/axiosConfig";
import { useFormik } from 'formik';
import Footer, {FooterTab, MobileFooter} from '../../Components/GreenHome/Footer';
import * as Yup from 'yup';
import Navbar from './RoundToJoin/navbar';

const Help = () => {
  const navigate = useNavigate();
  const userInfo = localStorage.getItem("userInfo");
  const parsedUserInfo = JSON.parse(userInfo);

  const [selectedIssueType, setSelectedIssueType] = useState(null);
  const [isMob, setIsMob] = useState(false);
  const [isTab, setIsTab] = useState(false);

  // Navbar related states
  const [selectedNav, setSelectedNav] = useState("");
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // API related states
  const [issueTypes, setIssueTypes] = useState([]);
  const [issueCreateSucc, setIssueCreateSucc] = useState("");
  const [issueCreateErr, setIssueCreateErr] = useState("");
  const [transactionIDErr, setTransactionIDErr] = useState(false);

  // Default issue options (fallback if API fails)
  const defaultIssueOptions = [
    { value: '1', label: 'Unable to Buy Tokens' },
    { value: '2', label: 'Payment Issues' },
    { value: '3', label: 'Account Problems' },
    { value: '4', label: 'Technical Support' },
    { value: '5', label: 'Unable to Play Game' },
    { value: '6', label: 'Unable to Withdraw Winnings' },
    { value: '7', label: 'Others' },
  ];

  // Define validation schema
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Please enter email"),
    issue: Yup.string()
      .required("Please enter your issue description"),
    issueType: Yup.string()
      .required("Please select an issue type"),
    // transactionId: Yup.string()
    //   .when('issueType', {
    //     is: (val) => val && ['38', '39'].includes(val),
    //     then: (schema) => schema.required("Transaction ID is required for this issue type"),
    //     otherwise: (schema) => schema.notRequired()
    //   })
    transactionId: Yup.string()
      .when('issueType', {
        is: (val) => {
          // Check if the selected issue type requires transaction ID based on label
          const transactionRequiredLabels = ['Unable to Buy Tokens', 'Unable to Withdraw'];
          return selectedIssueType && transactionRequiredLabels.includes(selectedIssueType.label);
        },
        then: (schema) => schema.required("Transaction ID is required for this issue type"),
        otherwise: (schema) => schema.notRequired()
      })
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      email: parsedUserInfo?.email || '',
      transactionId: '',
      issue: '',
      issueType: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const { email, transactionId, issue, issueType } = values;

      // Clear previous messages
      setIssueCreateSucc("");
      setIssueCreateErr("");
      setTransactionIDErr(false);

      try {
        const payload = {
          email: email.trim(),
          issue_category: Number(issueType),
          issue: issue.trim(),
        };

        // Add transaction_id only if it's provided and required
        if (transactionId && transactionId.trim()) {
          payload.transaction_id = transactionId.trim();
        }


        const res = await axios.post(`${baseURL}/accounts/tickets`, payload);

        if (res.data?.status === "Success" || res.status === 200) {
          setIssueCreateSucc("Query raised successfully!");
          resetForm();
          setSelectedIssueType(null);
        } else {
          setIssueCreateErr("Failed to raise query. Please try again.");
        }
      } catch (error) {
        console.error('Error submitting form:', error);

        // Handle specific error messages from API
        if (error.response?.data?.message) {
          setIssueCreateErr(error.response.data.message);
        } else if (error.response?.status === 400) {
          setIssueCreateErr("Invalid data provided. Please check your inputs.");
        } else if (error.response?.status === 500) {
          setIssueCreateErr("Server error. Please try again later.");
        } else {
          setIssueCreateErr("An error occurred while submitting your query. Please try again.");
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: `1px solid ${formik.touched.issueType && formik.errors.issueType ? '#EF4444' : '#D1D5DB'}`,
      borderRadius: '22px',
      backgroundColor: '#007FFF',
      color: '#FFFFFF',
      padding: isMob ? '2px 8px' : isTab ? '8px 10px' : '4px 12px',
      fontSize: isMob ? '12px' : '14px',
      boxShadow: 'none',
      borderColor: state.isFocused ? '#007FFF' : (formik.touched.issueType && formik.errors.issueType ? '#EF4444' : '#D1D5DB'),
      minHeight: isMob ? '40px' : isTab ? '44px' : '48px',
      height: isMob ? '40px' : isTab ? '44px' : '48px',
      '&:hover': {
        borderColor: state.isFocused ? '#007FFF' : '#9CA3AF',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: isTab ? 'center' : 'flex-start',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: '#FFFFFF',
      '&:hover': {
        color: '#FFFFFF',
      },
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.2s',
      marginTop: isTab ? '-4px' : '0',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      border: '1px solid #E5E7EB',
      marginTop: '4px',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '4px',
      borderRadius: '8px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#007FFF'
        : state.isFocused
          ? '#F3F4F6'
          : 'white',
      color: state.isSelected ? 'white' : '#374151',
      fontSize: isMob ? '12px' : '14px',
      padding: '8px 12px',
      borderRadius: '4px',
      margin: '2px 0',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: state.isSelected ? '#0056CC' : '#F3F4F6',
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#FFFFFF',
      fontSize: isMob ? '12px' : '14px',
      textAlign: isTab ? 'center' : 'left',
      marginBottom: isTab ? '4px' : '0',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#FFFFFF',
      fontSize: isMob ? '12px' : '14px',
      textAlign: isTab ? 'center' : 'left',
      marginBottom: isTab ? '4px' : '0',
    }),
  };

  // Toast notifications
  useEffect(() => {
    if (issueCreateSucc) {
      toast.success(issueCreateSucc, {
        onClose: () => {
          navigate("/help");
        },
        autoClose: 2000,
      });
    }
  }, [issueCreateSucc, navigate]);

  useEffect(() => {
    if (issueCreateErr) {
      toast.error(issueCreateErr, {
        onClose: () => { },
        autoClose: 2000,
      });
    }
  }, [issueCreateErr]);

  // Fetch issue types from API
  useEffect(() => {
    fetchIssueTypes();
  }, []);

  const fetchIssueTypes = async () => {
    const token = localStorage.getItem("access_token");
    try {
      const headers = {
        Authorization: `Bearer ${JSON.parse(token)}`,
      };
      const res = await axios.get(`${baseURL}/accounts/issuecategory`, { headers });

      if (res?.status === 200) {
        let issueData = [];

        if (res?.data?.data) {
          issueData = res.data.data;
        } else if (res?.data?.status === "Success" && res?.data?.data) {
          issueData = res.data.data;
        } else if (Array.isArray(res?.data)) {
          issueData = res.data;
        }

        // Transform API data to react-select format
        const transformedOptions = issueData.map(item => ({
          value: item.id?.toString() || item.value?.toString(),
          label: item.name || item.label || item.title
        }));

        if (transformedOptions.length > 0) {
          setIssueTypes(transformedOptions);
        } else {
          setIssueTypes(defaultIssueOptions);
        }
      }
    } catch (error) {
      console.error('Error fetching issue categories:', error);
      setIssueTypes(defaultIssueOptions);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 767) {
        setIsMob(true);
        setIsTab(false);
      } else if (window.innerWidth <= 1024) {
        setIsMob(false);
        setIsTab(true);
      } else {
        setIsMob(false);
        setIsTab(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const redirectHome = () => {
    navigate("/dashboard");
  };

  // const shouldShowTransactionId = () => {
  //   const validValues = ['38', '39'];
  //   return formik.values.issueType && validValues.includes(formik.values.issueType);
  // };

  const shouldShowTransactionId = () => {
    const transactionRequiredLabels = ['Unable to Buy Tokens', 'Unable to Withdraw'];
    return formik.values.issueType && selectedIssueType &&
      transactionRequiredLabels.includes(selectedIssueType.label);
  };

  const renderInput = () => {
    const inputHeight = isMob ? '40px' : isTab ? '44px' : '45px';

    return (
      <>
        <div className={`${isMob ? 'mx-2 mt-6' : 'mt-4 mx-auto max-w-4xl 2xl:min-w-[75%] 2xl:min-h-[75%]'} bg-white rounded-lg shadow-lg`}>
          <div className="h-[6px] rounded-tl-[12px] rounded-tr-[12px] bg-gradient-to-r from-[#00C05B] to-[#007FFF]" />
          <div className="p-8">
            <form onSubmit={formik.handleSubmit} className="space-y-4">
              <div
                className={`grid pt-2 ${isMob
                    ? 'grid-cols-1 gap-3'
                    : isTab
                      ? `${shouldShowTransactionId() ? 'grid-cols-3 gap-4' : 'grid-cols-2 gap-4'}`
                      : `${shouldShowTransactionId() ? 'grid-cols-3 gap-5' : 'grid-cols-2 gap-5'}`
                  }`}
              >
                {/* Email Field */}
                <div className="flex flex-col">
                  <label className={`text-[#00000099] font-medium mb-2 ${isMob ? 'text-xs' : 'text-sm'}`}>
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email ID"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{ height: inputHeight }}
                    className={`px-3 border ${formik.touched.email && formik.errors.email
                        ? 'border-red-500'
                        : 'border-gray-300'
                      } rounded-full ${isMob ? 'text-xs' : 'text-sm'} focus:outline-none focus:border-blue-500 transition-colors duration-300`}
                    required
                  />
                  {formik.touched.email && formik.errors.email && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.email}</span>
                  )}
                </div>

                {/* Issue Type Field */}
                <div className="flex flex-col">
                  <label className={`text-[#00000099] font-medium mb-2 ${isMob ? 'text-xs' : 'text-sm'}`}>
                    Select the issue
                  </label>
                  {/* <Select
                options={issueTypes}
                value={selectedIssueType}
                onChange={(selectedOption) => {
                  setSelectedIssueType(selectedOption);
                  formik.setFieldValue('issueType', selectedOption ? selectedOption.value : '');
                  
                  // Clear transaction ID if issue type doesn't require it
                  if (!selectedOption || !['38', '39'].includes(selectedOption.value)) {
                    formik.setFieldValue('transactionId', '');
                    setTransactionIDErr(false);
                  }
                }}
                onBlur={() => formik.setFieldTouched('issueType', true)}
                placeholder="Select Issue Type"
                styles={customSelectStyles}
                isSearchable={false}
                className='rounded-full'
              /> */}
                  <Select
                    options={issueTypes}
                    value={selectedIssueType}
                    onChange={(selectedOption) => {
                      setSelectedIssueType(selectedOption);
                      formik.setFieldValue('issueType', selectedOption ? selectedOption.value : '');

                      // Clear transaction ID if issue type doesn't require it based on label
                      const transactionRequiredLabels = ['Unable to Buy Tokens', 'Unable to Withdraw'];
                      if (!selectedOption || !transactionRequiredLabels.includes(selectedOption.label)) {
                        formik.setFieldValue('transactionId', '');
                        setTransactionIDErr(false);
                      }
                    }}
                    onBlur={() => formik.setFieldTouched('issueType', true)}
                    placeholder="Select Issue Type"
                    styles={customSelectStyles}
                    isSearchable={false}
                    className='rounded-full'
                  />
                  {formik.touched.issueType && formik.errors.issueType && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.issueType}</span>
                  )}
                </div>

                {/* Transaction ID Field (conditionally shown) */}
                {shouldShowTransactionId() && (
                  <div className={`flex flex-col ${!isMob && isTab ? 'col-span-2' : ''} ${!isMob && !isTab ? 'col-span-1' : ''}`}>
                    <label className={`text-[#00000099] font-medium mb-2 ${isMob ? 'text-xs' : 'text-sm'}`}>
                      Transaction ID
                    </label>
                    <input
                      type="text"
                      name="transactionId"
                      placeholder="Enter Transaction ID"
                      value={formik.values.transactionId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      style={{ height: inputHeight }}
                      className={`px-3 border ${formik.touched.transactionId && formik.errors.transactionId
                          ? 'border-red-500'
                          : 'border-gray-300'
                        } rounded-full ${isMob ? 'text-xs' : 'text-sm'} focus:outline-none focus:border-blue-500 transition-colors duration-300`}
                    />
                    {formik.touched.transactionId && formik.errors.transactionId && (
                      <span className="text-red-500 text-xs mt-1">{formik.errors.transactionId}</span>
                    )}
                  </div>
                )}
              </div>

              {/* Issue Description Field */}
              <div className="flex flex-col">
                <label className={`text-[#00000099] font-medium mb-2 ${isMob ? 'text-xs' : 'text-sm'}`}>
                  Describe your issue
                </label>
                <textarea
                  name="issue"
                  placeholder="Enter the issue in detail"
                  value={formik.values.issue}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  rows={isMob ? "3" : "4"}
                  className={`px-3 py-2 border ${formik.touched.issue && formik.errors.issue
                      ? 'border-red-500'
                      : 'border-gray-300'
                    } rounded-lg ${isMob ? 'text-xs' : 'text-sm'} focus:outline-none focus:border-blue-500 transition-colors duration-300 resize-vertical ${isMob ? 'min-h-[60px]' : 'min-h-[80px]'}`}

                />
                {formik.touched.issue && formik.errors.issue && (
                  <span className="text-red-500 text-xs mt-1">{formik.errors.issue}</span>
                )}
              </div>

              {/* Submit Buttons */}
              <div className="flex justify-start gap-4 pt-2">
                <button
                  type="submit"
                  disabled={formik.isSubmitting}
                  className={`${formik.isSubmitting
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-[#0081F8] hover:bg-[#0074E0]'
                    } text-white px-6 py-2 rounded-[30px] font-medium ${isMob ? 'text-xs' : 'text-sm'
                    } transition-colors duration-300`}
                >
                  {formik.isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
                <button
                  className={`px-6 py-3 text-[14px] mobile-m:text-[16px] text-[#FFFFFF] ${formik.isSubmitting
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-gray-500 hover:bg-gray-700'
                    } font-bold rounded-full focus:outline-none focus:shadow-outline`}
                  type="button"
                  disabled={formik.isSubmitting}
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  };

  // Placeholder footer components - replace with your actual components
  // const MobileFooter = () => <div className="h-16 bg-gray-800"></div>;
  // const FooterTab = () => <div className="h-20 bg-gray-800"></div>;
//  const Footer = () => <div className="h-24 bg-gray-800"></div>;

  return (
    <>
      <Navbar
        setDropdownOpen={setDropdownMenuOpen}
        setSelectedNav={setSelectedNav}
        selectedNav={selectedNav}
        setMobileMenuOpen={setMobileMenuOpen}
        setDropdownPos={setDropdownPos}
        dropdownPos={dropdownPos}
        dropdownOpen={dropdownMenuOpen}
        mobileMenuOpen={mobileMenuOpen}
        setOtherMenusOpen={setOtherMenusOpen}
        otherMenusOpen={otherMenusOpen}
      />

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Flip}
      />

      {isMob === true ? (
        <div
          className={`font-interFont overflow-auto ${isMob
              ? "bg-[url('../public/v2/images/bg/auth-bg-mobile.png')]"
              : "bg-[url('../public/v2/images/bg/auth-bg.png')]"
            } bg-cover`}
        >
          <div className="min-h-screen w-full px-2 py-5 font-Inter overflow-hidden">
            {/* <div className="flex w-full p-2 justify-between items-center border-b border-[#D3D3D31F] mx-auto">
              <div className="flex-shrink-0">
                <div
                  onClick={redirectHome}
                  className="h-16 w-auto cursor-pointer flex items-center"
                >
                  <div className="flex-shrink-0">
                    <img
                      src={pnpLogo}
                      alt="pickNdPrizes"
                      onClick={redirectHome}
                      className="h-14 w-auto"
                    />
                  </div>
                </div>
              </div>
            </div> */}

            <div>
              <div className="mt-16 px-2">
                <h2 className="text-[#FFFFFF] text-[18px] text-center">
                  How Can We Assist You?
                </h2>
                <p className="text-[12px] text-center text-[#FFFFFFB2] px-2 mb-2">
                  Please complete and submit the form below and our team will<br />
                  promptly reach out to assist you.
                </p>
              </div>

              {renderInput()}
            </div>
          </div>
          {
            isMob === true ?
             <MobileFooter /> : 
              <FooterTab />
          }
          {/* <MobileFooter /> */}
        </div>
      ) : isTab ? (
        <div className="h-screen overflow-hidden bg-[url('../public/v2/images/bg/auth-bg.png')] bg-cover help-page-tablet">
          <div className="h-full w-full p-5 font-interFont flex flex-col">
            <div className="flex w-full px-3 pb-5 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
              <div className="flex-shrink-0">
               
              </div>
            </div>

            <div className="flex-1 flex flex-col justify-center help-content-wrapper">
              <div className="text-center mt-8 mb-8 help-header">
                <h2 className="text-[#FFFFFF] text-lg text-center">
                  How Can We Assist You?
                </h2>
                <p className="text-[20px] text-center text-[#FFFFFFB2]">
                  Please complete and submit the form below and our team will<br />
                  promptly reach out to assist you.
                </p>
              </div>

              {renderInput()}
            </div>
            <FooterTab />
          </div>
        </div>
      ) : (
        <div className="flex flex-col min-h-screen overflow-hidden bg-[url('../public/v2/images/bg/auth-bg.png')] bg-cover">
          <div className="flex-1 h-full  w-full p-5 font-Inter flex flex-col">
            <div className="flex p-3 items-center justify-between w-[95%] mx-auto">
              <div className="flex-shrink-0">
                <div
                  onClick={redirectHome}
                  className="h-24 cursor-pointer flex items-center"
                >
                  {/* <div className="flex-shrink-0">
                    <img
                      src={pnpLogo}
                      alt="pickNdPrizes"
                      onClick={redirectHome}
                      className="h-20 w-auto"
                    />
                  </div> */}
                </div>
              </div>
            </div>

            <div className=" justify-center 2xl:min-h-[50%]">
              <div className="text-center mb-2">
                <h2 className="font-archivo text-white text-[32px] md:text-[32px] font-semibold leading-tight">
                  How can we assist you?
                </h2>
                <p className="font-archivo text-[16px] md:text-[16px] text-[#FFFFFFB2] mt-4 leading-snug max-w-xl mx-auto">
                  Please complete and submit the form below and our team will<br />
                  promptly reach out to assist you.
                </p>
              </div>

              {renderInput()}
            </div>
          </div>
          <>      
          <FooterTab componnent="rules" />        
          </>
        </div>
      )}
    </>
  );
};

export default Help;